import * as React from "react"

const Female = (props) => {
    const { color, size } = props
    return (<svg width={size ? size : "1200pt"} height={size ? size : "1200pt"} version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg" alt="Plus icon">
        <path
            d="m600 343.06c-104.07 0-188.93 84.855-188.93 188.93 0 96.43 72.773 176.29 166.26 187.51v31.645h-37.785c-12.52 0-22.672 10.148-22.672 22.672 0 12.52 10.148 22.672 22.672 22.672h37.785v37.785c0 12.52 10.148 22.672 22.672 22.672 12.52 0 22.672-10.152 22.672-22.672v-37.785h37.785c12.52 0 22.672-10.152 22.672-22.672 0-12.52-10.148-22.672-22.672-22.672h-37.785v-31.645c93.484-11.223 166.26-91.082 166.26-187.51 0-104.07-84.855-188.93-188.93-188.93zm0 45.344c79.57 0 143.59 64.02 143.59 143.59 0 79.566-64.016 143.59-143.59 143.59s-143.59-64.02-143.59-143.59c0-79.566 64.016-143.59 143.59-143.59z"
            fill={color}
        />
    </svg>)
}

export default Female